"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4665],{

/***/ 71285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ List_List; },
  "H": function() { return /* reexport */ List_ListItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/List/List.jsx






var List = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, gap = param.gap, tag = param.tag, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(List, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            gap: gap
        })
    }).className;
    var TagName = tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagName, {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
List.displayName = "List";
List.propTypes = {
    children: (prop_types_default()).node,
    gap: (prop_types_default()).number,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    tag: (prop_types_default()).string
};
List.defaultProps = {
    mix: {},
    mods: {},
    tag: "ul"
};
/* harmony default export */ var List_List = (List);

// EXTERNAL MODULE: ./node_modules/lodash/isBoolean.js
var isBoolean = __webpack_require__(51584);
var isBoolean_default = /*#__PURE__*/__webpack_require__.n(isBoolean);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/List/ListItem.jsx








var ListItem = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, action = param.action, href = param.href, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(ListItem, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            action: action
        })
    }).className;
    return action ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
ListItem.displayName = "List__Item";
ListItem.propTypes = {
    action: function action(props, propName, componentName) {
        if (props.action !== undefined && !isBoolean_default()(props.action)) {
            return new Error("The prop `" + propName + "` is marked as required in" + " `" + componentName + "`, but its value is `undefined`");
        }
        if (props.to !== undefined && props.action === undefined) {
            return new Error("The prop `" + propName + "` is marked as required with the prop `to` in" + " `" + componentName + "` but its value is `undefined`");
        }
    },
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    href: (prop_types_default()).string
};
ListItem.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var List_ListItem = (ListItem);

;// CONCATENATED MODULE: ./src/components/List/index.js





/***/ }),

/***/ 25068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

var Collapsed = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    default: false,
    key: "navbarCollapsed"
});
/* harmony default export */ __webpack_exports__["Z"] = (Collapsed);


/***/ }),

/***/ 49719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wp": function() { return /* reexport */ Navbar_Navbar; },
  "UG": function() { return /* reexport */ Navbar_NavbarBrand; },
  "kF": function() { return /* reexport */ Navbar_NavbarCollapse; },
  "f$": function() { return /* reexport */ Navbar_NavbarCollapseHeader; },
  "kz": function() { return /* reexport */ Navbar_NavbarNav; },
  "w9": function() { return /* reexport */ Navbar_NavbarSubnav; },
  "WR": function() { return /* reexport */ Navbar_NavbarToggler; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Navbar/Navbar.jsx





var Navbar = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Navbar, {
        mix: mix,
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
Navbar.displayName = "Navbar";
Navbar.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Navbar.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Navbar/NavbarBrand.jsx





var NavbarBrand = function(param) {
    var children = param.children, mods = param.mods, href = param.href, title = param.title;
    var className = (0,useMods/* default */.Z)(NavbarBrand, {
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        title: title,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            children: children
        })
    });
};
NavbarBrand.displayName = "Navbar-Brand";
NavbarBrand.propTypes = {
    children: (prop_types_default()).node,
    className: (prop_types_default()).string,
    href: (prop_types_default()).string.isRequired,
    mods: (prop_types_default()).object,
    title: (prop_types_default()).string
};
NavbarBrand.defaultProps = {
    mods: {}
};
/* harmony default export */ var Navbar_NavbarBrand = (NavbarBrand);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/Navbar/atoms/Collapsed.js
var Collapsed = __webpack_require__(25068);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./src/components/Navbar/NavbarCollapse.jsx







var NavbarCollapse = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(NavbarCollapse, {
        mix: mix,
        mods: mods
    }, true).className;
    // const collapsed = useRecoilValue(atomCollapsed);
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(Collapsed/* default */.Z), 2), collapsed = ref[0], setCollapsed = ref[1];
    var ref1 = (0,react.useRef)();
    var handleOutsideClick = function(e) {
        if (ref1.current && !ref1.current.contains(e.target)) {
            setCollapsed(false);
        }
    };
    (0,react.useEffect)(function() {
        document.body.addEventListener("click", handleOutsideClick);
        return function() {
            document.body.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        className: className + (collapsed ? " collapsed" : ""),
        children: children
    });
};
NavbarCollapse.displayName = "Navbar-Collapse";
NavbarCollapse.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
NavbarCollapse.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Navbar_NavbarCollapse = (NavbarCollapse);

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarCollapseHeader.jsx




var NavbarCollapseHeader = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(NavbarCollapseHeader, {
        mix: mix,
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
NavbarCollapseHeader.displayName = "Navbar-Collapse-Header";
NavbarCollapseHeader.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
NavbarCollapseHeader.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Navbar_NavbarCollapseHeader = (NavbarCollapseHeader);

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarNav.jsx




var NavbarNav = function(param) {
    var children = param.children, mods = param.mods;
    var className = (0,useMods/* default */.Z)(NavbarNav, {
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: className,
        children: children
    });
};
NavbarNav.displayName = "Navbar-Nav";
NavbarNav.propTypes = {
    children: (prop_types_default()).node,
    mods: (prop_types_default()).object
};
NavbarNav.defaultProps = {
    mods: {}
};
/* harmony default export */ var Navbar_NavbarNav = (NavbarNav);

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarSubnav.jsx




var NavbarSubnav = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(NavbarSubnav, {
        mix: mix,
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
NavbarSubnav.displayName = "Navbar-Subnav";
NavbarSubnav.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    onMouseEnter: (prop_types_default()).func,
    onMouseLeave: (prop_types_default()).func
};
NavbarSubnav.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Navbar_NavbarSubnav = (NavbarSubnav);

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarToggler.jsx





var NavbarToggler = function(param) {
    var children = param.children, mods = param.mods, onClick = param.onClick, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(NavbarToggler, {
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (0,css/* default */.Z)(className, classNameTail),
        onClick: onClick,
        role: "button",
        "aria-label": "Toggle navbar",
        children: children
    });
};
NavbarToggler.displayName = "Navbar-Toggler";
NavbarToggler.propTypes = {
    children: (prop_types_default()).node,
    mods: (prop_types_default()).object,
    onClick: (prop_types_default()).func
};
NavbarToggler.defaultProps = {
    mods: {}
};
/* harmony default export */ var Navbar_NavbarToggler = (NavbarToggler);

;// CONCATENATED MODULE: ./src/components/Navbar/index.js










/***/ }),

/***/ 62211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Portal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/components/Portal/Portal.jsx





var Portal = function(param) {
    var mods = param.mods, children = param.children;
    var className = (0,useMods/* default */.Z)(Portal, {
        mods: mods
    }).className;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
        return function() {
            return setMounted(false);
        };
    }, []);
    return mounted && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    }), document.querySelector("#portal"));
};
Portal.displayName = "Portal";
Portal.propTypes = {
    mods: (prop_types_default()).object,
    children: (prop_types_default()).node
};
Portal.defaultProps = {
    mods: {}
};
/* harmony default export */ var Portal_Portal = (Portal);

;// CONCATENATED MODULE: ./src/components/Portal/index.js

/* harmony default export */ var components_Portal = (Portal_Portal);


/***/ }),

/***/ 56860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useEventHandler = function(eventName, eventHandler, eventTarget) {
    var eventHandlerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        eventHandlerRef.current = eventHandler;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!eventTarget) {
            eventTarget = window;
        }
        var handleEvent = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _eventHandlerRef;
            return eventHandlerRef === null || eventHandlerRef === void 0 ? void 0 : (_eventHandlerRef = eventHandlerRef).current.apply(_eventHandlerRef, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(args));
        };
        eventTarget.addEventListener(eventName, handleEvent);
        return function() {
            return eventTarget.removeEventListener(eventName, handleEvent);
        };
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventHandler);


/***/ }),

/***/ 94665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Traqq; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Info/index.js + 1 modules
var Info = __webpack_require__(54491);
// EXTERNAL MODULE: ./src/components/List/index.js + 2 modules
var List = __webpack_require__(71285);
// EXTERNAL MODULE: ./src/components/Nav/index.js + 3 modules
var Nav = __webpack_require__(19812);
// EXTERNAL MODULE: ./src/components/Navbar/index.js + 7 modules
var Navbar = __webpack_require__(49719);
// EXTERNAL MODULE: ./src/components/Navbar/atoms/Collapsed.js
var Collapsed = __webpack_require__(25068);
// EXTERNAL MODULE: ./src/components/Portal/index.js + 1 modules
var Portal = __webpack_require__(62211);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/ButtonGroup/index.js + 1 modules
var ButtonGroup = __webpack_require__(37938);
// EXTERNAL MODULE: ./src/components/UI/Divider/index.js + 1 modules
var Divider = __webpack_require__(42080);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/components/UI/Link/index.js + 1 modules
var Link = __webpack_require__(57202);
// EXTERNAL MODULE: ./src/components/UI/Logo/index.js + 1 modules
var Logo = __webpack_require__(61316);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
// EXTERNAL MODULE: ./src/hooks/useEventHandler/index.jsx
var useEventHandler = __webpack_require__(56860);
// EXTERNAL MODULE: ./src/hooks/useUtmTags/index.jsx
var useUtmTags = __webpack_require__(88194);
// EXTERNAL MODULE: ./src/utils/renderIf.js
var renderIf = __webpack_require__(79810);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./src/layouts/Navigation/Traqq/data.js
/* harmony default export */ var data = ([
    {
        id: 1,
        link: "/",
        title: "Main"
    },
    {
        desc: "Explore the four key features of Traqq in greater detail",
        id: 2,
        link: "",
        subnav_title_link: "".concat("https://traqq.com", "/features/"),
        subnav_title_alt: "Time Tracking Features of Traqq",
        subnav: [
            {
                desc: "Track the work hours of your employees accurately.",
                icon: "timer",
                id: 1,
                link: "/time-tracking",
                title: "Time tracking"
            },
            {
                desc: "Monitor employee activities from various angles.",
                icon: "monitoring",
                id: 2,
                link: "/features/employee-monitoring-software/",
                title: "Employee monitoring"
            },
            {
                desc: "Manage admins, managers, and users effortlessly.",
                icon: "settings",
                id: 3,
                link: "/team-management",
                title: "Team management"
            },
            {
                desc: "Automatically create sophisticated team reports.",
                icon: "graph",
                id: 4,
                link: "/features/online-time-reporting-system/",
                title: "Team analysis and reporting"
            }
        ],
        title: "Features"
    },
    {
        desc: "Whether you are a large organization with many employees, or a freelancer looking to track work hours, Traqq is for you!",
        id: 3,
        link: "",
        subnav: [
            {
                desc: "Track the work hours of everyone in your company.",
                icon: "enterprises",
                id: 1,
                link: "".concat("https://traqq.com", "/use-cases/enterprise-time-tracking-software/"),
                title: "Enterprises"
            },
            {
                desc: "Businesses of any size use and benefit from Traqq.",
                icon: "businesses",
                id: 2,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-app-for-small-businesses/"),
                title: "Businesses"
            },
            {
                desc: "Traqq is great for agencies with remote employees.",
                icon: "atom",
                id: 3,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-software-for-agencies/"),
                title: "Agencies"
            },
            {
                desc: "Teams big or small can track time and create reports.",
                icon: "teams",
                id: 4,
                link: "/time-tracking-app-for-teams",
                title: "Teams"
            },
            {
                desc: "Traqq’s free plan is the best for tracking freelancer work.",
                icon: "freelancers",
                id: 5,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-software-for-freelancers/"),
                title: "Freelancers"
            }
        ],
        title: "Use Cases"
    },
    {
        id: 4,
        link: "/pricing",
        title: "Pricing"
    },
    {
        id: 5,
        link: "/support",
        title: "Help Center"
    },
    {
        desc: "Learn about Traqq or explore our blog to gain valuable knowledge in employee management, freelancing, productivity and so much more. Got a question? Drop us a message",
        id: 6,
        link: "",
        subnav: [
            {
                desc: "We are a team of bright, driven, and passionate people working hard to provide you with the best time tracker.",
                icon: "about-us",
                id: 1,
                link: "/about",
                title: "About Us"
            },
            {
                desc: "Got a question? Drop us an email or fill out the form.",
                icon: "email",
                id: 3,
                link: "/contact",
                title: "Contact Us"
            }
        ],
        title: "Company"
    },
    {
        desc: "Explore our blog to find the coolest productivity tips and hottest news in the industry.",
        icon: "blog",
        id: 7,
        link: "".concat("https://traqq.com/blog", "/"),
        title: "Blog"
    }
]);

;// CONCATENATED MODULE: ./src/layouts/Navigation/Traqq/Navigation.jsx

























var Navigation = function(param) {
    var theme = param.theme, background = param.background;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, isReady = ref.isReady;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(Collapsed/* default */.Z), 2), collapsed = ref1[0], setCollapsed = ref1[1];
    var ref2 = (0,react.useState)([]), clickedIndexes = ref2[0], setClickedIndexes = ref2[1];
    var breakWidth = 1280;
    var handleNavClick = function(index) {
        if (window.innerWidth > breakWidth) return;
        var updatedClickedIndexes = (0,_to_consumable_array/* default */.Z)(clickedIndexes);
        if (updatedClickedIndexes.includes(index)) {
            updatedClickedIndexes.splice(updatedClickedIndexes.indexOf(index), 1);
        } else {
            updatedClickedIndexes.push(index);
        }
        setClickedIndexes(updatedClickedIndexes);
    };
    var handleTogglerClick = function() {
        return setCollapsed(!collapsed);
    };
    var onResize = function() {
        // reset nav
        if (window.innerWidth > breakWidth) {
            setCollapsed(false);
            setClickedIndexes([]);
        }
    };
    (0,useEventHandler/* default */.Z)("resize", onResize);
    (0,react.useEffect)(function() {
        return setCollapsed(false);
    }, []);
    var OffCanvas = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* NavbarCollapse */.kF, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* NavbarCollapseHeader */.f$, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* NavbarBrand */.UG, {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                            type: "dark"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* NavbarToggler */.WR, {
                        onClick: handleTogglerClick,
                        className: "w-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "burger-" + (!collapsed ? "open" : "close"),
                            color: "neutral-900",
                            size: 32,
                            mods: {
                                block: true
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* NavbarNav */.kz, {
                children: data.map(function(nav) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Nav/* NavItem */.LY, {
                        onClick: function() {
                            handleNavClick(nav.id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* NavLink */.OL, {
                                className: "whitespace-nowrap",
                                href: nav.link,
                                children: [
                                    nav.title,
                                    nav.subnav && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        className: clickedIndexes.includes(nav.id) ? "rotate-180" : "",
                                        name: "chevron-down",
                                        size: 12,
                                        color: "#"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                isTrue: nav.subnav,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* NavbarSubnav */.w9, {
                                    mods: {
                                        show: clickedIndexes.includes(nav.id)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                                            gap: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "heading h2",
                                                    children: nav.subnav_title_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: nav.subnav_title_link,
                                                        linkProps: {
                                                            title: nav.subnav_title_alt
                                                        },
                                                        children: nav.title
                                                    }) : nav.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: nav.desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                                            mods: {
                                                subnav: true
                                            },
                                            children: (ref = nav.subnav) === null || ref === void 0 ? void 0 : ref.map(function(subnav) {
                                                var navLink = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            name: subnav.icon,
                                                            color: [
                                                                "violet-500",
                                                                "neutral-700"
                                                            ],
                                                            size: 32
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                    tag: "span",
                                                                    className: "h4",
                                                                    children: subnav.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                    tag: "p",
                                                                    children: subnav.desc
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.H, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavLink */.OL, {
                                                        href: subnav.link,
                                                        children: navLink
                                                    })
                                                }, subnav.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, nav.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                direction: "col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        tag: "a",
                        type: "link",
                        href: "".concat("https://newapp.traqq.com", "/signup"),
                        variant: "primary",
                        mods: {
                            signup: true
                        },
                        children: "Organization Signup"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        tag: "a",
                        type: "link",
                        href: "".concat("https://newapp.traqq.com", "/login"),
                        color: "violet",
                        variant: "outline_primary",
                        mods: {
                            signin: true
                        },
                        children: "Log In"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        tag: "a",
                        type: "link",
                        href: (0,useUtmTags/* default */.Z)("/demo", {
                            utm_medium: "CTA_header"
                        }),
                        color: "violet",
                        variant: "outline_primary",
                        mods: {
                            demo: true
                        },
                        className: "768:hidden",
                        children: "Demo"
                    })
                ]
            })
        ]
    });
    (0,react.useEffect)(function() {
        if (isReady) {
            var body = document.getElementsByTagName("body")[0];
            collapsed ? body.classList.add("no-scroll") : body.classList.remove("no-scroll");
        }
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar */.wp, {
                mods: {
                    background: background,
                    theme: theme,
                    sticky: true
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between py-4 gap-x-16p 1280:py-7 container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* NavbarBrand */.UG, {
                                    href: "/",
                                    title: "Go to the main page",
                                    className: "!mr-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                        type: theme === "dark" ? "light" : "dark"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                    isTrue: !collapsed,
                                    children: OffCanvas
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                            mix: {
                                "navbar-button-group": true
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    tag: "a",
                                    type: "link",
                                    href: (0,useUtmTags/* default */.Z)("/demo", {
                                        utm_medium: "CTA_header"
                                    }),
                                    variant: "tertiary",
                                    mods: {
                                        demo: true,
                                        white: pathname.includes("traqq-discount")
                                    },
                                    className: "!py-10p !px-20p",
                                    children: "Demo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    variant: "vertical",
                                    style: "dotted"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    id: "button-login",
                                    tag: "a",
                                    type: "link",
                                    href: "".concat("https://newapp.traqq.com", "/login"),
                                    variant: "tertiary",
                                    mods: {
                                        signin: true,
                                        white: pathname.includes("traqq-discount")
                                    },
                                    className: "!hidden 480:!inline whitespace-nowrap !py-10p !px-20p",
                                    children: "Log In"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    tag: "a",
                                    type: "link",
                                    href: (0,useUtmTags/* default */.Z)("".concat("https://newapp.traqq.com", "/signup"), {
                                        utm_medium: "CTA_header"
                                    }),
                                    variant: background !== "violet" ? "primary" : "secondary",
                                    mods: {
                                        signup: true
                                    },
                                    className: "!text-14p whitespace-nowrap max-480:w-10.5 max-480:h-10.5 max-480:!p-2.5 max-480:!leading-3 !px-23p !py-10p",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: "enter",
                                            size: 20,
                                            color: "#F9F9FD",
                                            className: "480:!hidden"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "max-480:hidden",
                                            children: "Organization Signup"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* NavbarToggler */.WR, {
                                    mods: {
                                        "sm-dark": pathname.includes("traqq-discount")
                                    },
                                    onClick: handleTogglerClick,
                                    className: "ml-4 480:ml-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "burger-" + (!collapsed ? "open" : "close"),
                                        color: theme === "dark" ? "#ffffff" : "neutral-900",
                                        mods: {
                                            block: true
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: collapsed,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
                    children: OffCanvas
                })
            })
        ]
    });
};
Navigation.displayName = "Navigation";
Navigation.propTypes = {
    background: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
/* harmony default export */ var Traqq_Navigation = (Navigation);

;// CONCATENATED MODULE: ./src/layouts/Navigation/Traqq/index.js

/* harmony default export */ var Traqq = (Traqq_Navigation);


/***/ })

}]);